/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EventProfileProviderQueryVariables = {
    eventCuid: string;
    userId: string;
};
export type EventProfileProviderQueryResponse = {
    readonly event_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly publishedAt: string | null;
                readonly cuid: string;
                readonly " $fragmentRefs": FragmentRefs<"helpers_useGetIsEventAtCapacity_public_event" | "EventProfileView_event" | "AlreadyRegisteredInfo_event" | "NonCategoriedRegisterMobile_public_event" | "NonCategoriedRegistrationCard_public_event" | "SeeDatesDialog_public_event" | "CategoriedRegistrationCard_public_event" | "CategoriedRegisterMobile_public_event" | "RefineCategoriesCard_public_event" | "OccurrenceSelector_public_event" | "EventTitle_public_event" | "DesktopPicture_public_event" | "MobilePicture_public_event" | "OrganizerInfo_public_event" | "PricesCategoriedPrices_public_event" | "PricesNonCategoriedPrices_public_event" | "AboutSection_public_event" | "AdditionalInformationSection_public_event" | "CategoriesSection_public_event" | "CategoryInfo_public_event" | "ViewParticipantsDialog_public_event" | "CoursesSection_public_event" | "ScheduleSection_public_event" | "SeriesSection_public_event" | "CoachesSection_public_event" | "VibeSection_public_event" | "AmenitiesSection_public_event" | "VirtualSection_public_event" | "LocationSection_public_event" | "ChecklistSection_public_event" | "ProgramSection_public_event" | "TicketsSection_public_event" | "SponsorsSection_public_event" | "OrganizerInfoSection_public_event" | "QuestionAnswerContainer_public_event" | "UpdateContainer_public_event" | "OrganizerReviewsSection_public_event" | "RelatedEvents_public_event" | "ReviewsSection_public_event">;
            };
        }>;
    };
};
export type EventProfileProviderQuery = {
    readonly response: EventProfileProviderQueryResponse;
    readonly variables: EventProfileProviderQueryVariables;
};



/*
query EventProfileProviderQuery(
  $eventCuid: String!
  $userId: String!
) {
  event_connection(where: {_and: [{cuid: {_eq: $eventCuid}}, {deleted_at: {_is_null: true}}]}) {
    edges {
      node {
        id
        publishedAt
        cuid
        ...helpers_useGetIsEventAtCapacity_public_event
        ...EventProfileView_event
        ...AlreadyRegisteredInfo_event
        ...NonCategoriedRegisterMobile_public_event
        ...NonCategoriedRegistrationCard_public_event
        ...SeeDatesDialog_public_event
        ...CategoriedRegistrationCard_public_event
        ...CategoriedRegisterMobile_public_event
        ...RefineCategoriesCard_public_event
        ...OccurrenceSelector_public_event
        ...EventTitle_public_event
        ...DesktopPicture_public_event
        ...MobilePicture_public_event
        ...OrganizerInfo_public_event
        ...PricesCategoriedPrices_public_event
        ...PricesNonCategoriedPrices_public_event
        ...AboutSection_public_event
        ...AdditionalInformationSection_public_event
        ...CategoriesSection_public_event
        ...CategoryInfo_public_event
        ...ViewParticipantsDialog_public_event
        ...CoursesSection_public_event
        ...ScheduleSection_public_event
        ...SeriesSection_public_event
        ...CoachesSection_public_event
        ...VibeSection_public_event
        ...AmenitiesSection_public_event
        ...VirtualSection_public_event
        ...LocationSection_public_event
        ...ChecklistSection_public_event
        ...ProgramSection_public_event
        ...TicketsSection_public_event
        ...SponsorsSection_public_event
        ...OrganizerInfoSection_public_event
        ...QuestionAnswerContainer_public_event
        ...UpdateContainer_public_event
        ...OrganizerReviewsSection_public_event
        ...RelatedEvents_public_event
        ...ReviewsSection_public_event
      }
    }
  }
}

fragment AboutSection_public_event on event {
  id
  description
}

fragment AdditionalInformationSection_public_event on event {
  id
  refundInfo
  eventWebsite
  eventPrograms {
    defaultPrice
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    entryFee
    id
  }
  eventAdditionalInfos {
    id
    title
    description
  }
}

fragment AlreadyRegisteredInfo_event on event {
  cuid
  occurrenceLabel
  eventMetadata {
    name
    id
  }
}

fragment AmenitiesSection_public_event on event {
  id
  eventAmenities(order_by: {amenity: {name: asc}}) {
    id
    amenity {
      id
      name
      imageUrl
      info
    }
  }
}

fragment CategoriedRegisterMobile_public_event on event {
  cuid
  activity
  publishedAt
  startDate
  endDate
  canceledAt
  isVirtualEvent
  regCloseDate
  currencyCode
  occurrenceLabel
  isRegistrationPaused
  eventMetadata {
    isCategoriedEvent
    slug
    name
    id
  }
  organizer {
    slug
    cuid
    id
  }
  eventVenues {
    venue {
      id
      timezone
      city
      state
      country
      lat
      lng
    }
    id
  }
  eventVirtualVenues {
    timezone
    id
  }
  eventPrograms {
    defaultPrice
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
    entryFee
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
}

fragment CategoriedRegistrationCard_public_event on event {
  id
  cuid
  activity
  currencyCode
  startDate
  endDate
  publishedAt
  regCloseDate
  canceledAt
  isVirtualEvent
  isRegistrationPaused
  occurrenceLabel
  eventMetadata {
    slug
    name
    id
  }
  organizer {
    id
    cuid
    name
    slug
  }
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
    cuid
    name
    entryFee
    eventDiscipline {
      disciplineName
      id
    }
  }
  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {
    id
    cuid
    name
    price
  }
  eventVenues {
    id
    venue {
      id
      timezone
      city
      state
      country
      lat
      lng
    }
  }
  eventVirtualVenues {
    timezone
    id
  }
}

fragment CategoriesSection_public_event on event {
  id
  cuid
  currencyCode
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventDisciplines(order_by: {disciplineName: asc}) {
    cuid
    disciplineName
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
    cuid
    name
    entryFee
    gender
    minAge
    maxAge
    description
    spotsAvailable
    spotsRemaining
    abilityLevelRange
    additionalPrizes
    eventCuid
    eventDisciplineCuid
    eventDiscipline {
      disciplineName
      id
    }
    categoryCourses {
      id
      course {
        id
        cuid
        name
        platformId
        courseLength
        courseLengthType
        courseLengthSecondary
        courseLengthTypeSecondary
        difficultyName
        distance
        totalElevationGain
        totalElevationLoss
        fullName
      }
    }
    eventScheduleCategories {
      id
      eventSchedule {
        id
        title
        startTime
        endTime
        eventScheduleTypeCustom {
          id
          cuid
          type
          color
          isPreset
        }
        eventScheduleTypePreset {
          id
          cuid
          isPreset
          scheduleTypePresetCuid
          scheduleTypePreset {
            id
            cuid
            type
            color
            isPreset
          }
        }
        eventScheduleDate {
          date
          id
        }
      }
    }
  }
}

fragment CategoryInfo_public_event on event {
  id
  cuid
  eventSanctions {
    id
    cuid
    eventCuid
    otherSanctionName
    permit
    sanctionCuid
    appliesToAllCategories
    allowOneDayLicense
    isLicenseRequired
    oneDayFee
    eventSanctionCategories {
      id
      cuid
      categoryCuid
      eventSanctionCuid
    }
    sanction {
      id
      cuid
      name
      hasPermit
      waiverLink
      isOneDayAvailable
      country
      website
      oneDayFee
    }
  }
}

fragment ChecklistSection_public_event on event {
  id
  activity
  eventChecklistItems {
    id
    name
    info
  }
}

fragment CoachesSection_public_event on event {
  id
  nonCanceledClinics: clinics(where: {canceledAt: {_is_null: true}}) {
    clinicCoaches {
      coach {
        cuid
        user {
          id
          firstName
          lastName
          slug
          pronouns
          profilePicUrl
          instagramProfile
          facebookProfile
          stravaProfile
          coach {
            id
            isSuperCoach
            allowRequests
            organizerCuidToDisplay
            coachingVibe
            coachDisciplines {
              name
              id
            }
            coachStudents {
              languages
              id
            }
            coachLocations {
              city
              state
              countryCode
              country
              id
            }
            organizer {
              name
              slug
              id
            }
          }
        }
        id
      }
      id
    }
    id
  }
}

fragment CoursesSection_public_event on event {
  id
  cuid
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
  }
  courses(order_by: [{eventDiscipline: {disciplineName: asc}}, {platformId: asc_nulls_last}, {difficultyName: asc}]) {
    id
    platform
    platformId
    platformUrl
    cuid
    name
    fullName
    description
    difficultyName
    eventDisciplineCuid
    distance
    elevationHigh
    elevationLow
    elevationUnit
    totalElevationGain
    totalElevationLoss
    maxGrade
    geoJson
    startLat
    startLng
    endLat
    endLng
    city
    state
    country
    eventCuid
    courseLength
    courseLengthType
    courseLengthSecondary
    courseLengthTypeSecondary
    eventDiscipline {
      id
      disciplineName
    }
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
      categoryCuid
    }
  }
}

fragment DesktopPicture_public_event on event {
  eventImages(order_by: {position: asc}) {
    id
    image {
      id
      relativeUrl
    }
  }
}

fragment EventProfileView_event on event {
  cuid
  activity
  isVirtualEvent
  isCourseEvent
  occurrenceLabel
  refundInfo
  eventMetadata {
    name
    isCategoriedEvent
    id
  }
  organizer {
    name
    about
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
    entryFee
  }
  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {
    id
  }
  eventSeries(where: {deleted_at: {_is_null: true}}) {
    id
  }
  eventAmenities(order_by: {amenity: {name: asc}}) {
    id
  }
  eventChecklistItems {
    id
  }
  eventSponsors(order_by: {position: asc}) {
    id
  }
  eventAdditionalInfos {
    id
  }
  eventPrograms {
    defaultPrice
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    priceOverride
    id
  }
}

fragment EventTitle_public_event on event {
  cuid
  activity
  startDate
  endDate
  publishedAt
  isVirtualEvent
  eventVenues {
    venue {
      name
      city
      state
      country
      id
    }
    id
  }
  eventMetadata {
    isCategoriedEvent
    name
    id
  }
}

fragment LocationSection_public_event on event {
  id
  startDate
  endDate
  eventVenues {
    id
    parkingInfo
    campingDescription
    additionalInfo
    venue {
      lat
      lng
      name
      fullAddress
      id
    }
  }
}

fragment MobilePicture_public_event on event {
  id
  cuid
  publishedAt
  eventImages(order_by: {position: asc}) {
    id
    image {
      id
      relativeUrl
    }
  }
}

fragment NonCategoriedRegisterMobile_public_event on event {
  currencyCode
  occurrenceLabel
  eventMetadata {
    name
    id
  }
}

fragment NonCategoriedRegistrationCard_public_event on event {
  cuid
  activity
  currencyCode
  nonCategoriedRegDeadline
  eventPrograms {
    defaultPrice
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    spotsAvailable
    spotsRemaining
    registrationStatus
    event {
      cuid
      activity
      currencyCode
      isVirtualEvent
      nonCategoriedRegDeadline
      organizer {
        cuid
        id
      }
      eventMetadata {
        name
        id
      }
      eventPrograms {
        defaultPrice
        id
      }
      eventVenues {
        venue {
          timezone
          city
          state
          country
          lat
          lng
          id
        }
        id
      }
      id
    }
    rideDays {
      startTime
      id
    }
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    spotsAvailable
    spotsRemaining
    meetingLink
    registrationStatus
    event {
      cuid
      activity
      currencyCode
      isVirtualEvent
      nonCategoriedRegDeadline
      organizer {
        cuid
        id
      }
      eventMetadata {
        name
        id
      }
      eventPrograms {
        defaultPrice
        id
      }
      eventVirtualVenues {
        timezone
        id
      }
      eventVenues {
        venue {
          timezone
          city
          state
          country
          lat
          lng
          id
        }
        id
      }
      id
    }
    clinicDays {
      cuid
      startTime
      eventClinicDayDuration {
        dayNumber
        duration
        id
      }
      id
    }
    id
  }
}

fragment OccurrenceSelector_public_event on event {
  startDate
  endDate
  eventMetadata {
    isCategoriedEvent
    events(where: {_and: [{deleted_at: {_is_null: true}}, {eventAccess: {_eq: Public}}]}) {
      cuid
      occurrenceLabel
      id
    }
    id
  }
}

fragment OrganizerInfoSection_public_event on event {
  id
  cuid
  activity
  additionalContactInfo
  occurrenceLabel
  eventMetadata {
    name
    id
  }
  organizer {
    cuid
    name
    about
    slug
    created_at
    image {
      relativeUrl
      id
    }
    id
  }
}

fragment OrganizerInfo_public_event on event {
  id
  activity
  currencyCode
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  organizer {
    id
    name
    slug
    image {
      relativeUrl
      id
    }
  }
}

fragment OrganizerReviewsSection_public_event on event {
  id
  organizer {
    id
    name
    slug
    image {
      id
      relativeUrl
    }
  }
}

fragment PricesCategoriedPrices_public_event on event {
  id
  activity
  currencyCode
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    id
    entryFee
  }
}

fragment PricesNonCategoriedPrices_public_event on event {
  id
  activity
  currencyCode
  eventPrograms {
    defaultPrice
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    clinicDays {
      startTime
      id
    }
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    rideDays {
      startTime
      id
    }
    id
  }
}

fragment ProgramSection_public_event on event {
  id
  cuid
  currencyCode
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  eventPrograms {
    id
    cuid
    overview
    skills
    genders
    focus
    ageRange
    abilityLevelRange
    defaultPrice
  }
}

fragment QuestionAnswerContainer_public_event on event {
  id
  cuid
  eventQuestions(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {
    cuid
    title
    userId
    deleted_at
    created_at
    user {
      firstName
      lastName
      id
    }
    eventQuestionAnswers(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {
      cuid
      body
      deleted_at
      created_at
      isOrganizer
      userId
      user {
        firstName
        lastName
        id
      }
      id
    }
    id
  }
}

fragment RefineCategoriesCard_public_event on event {
  id
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    cuid
    name
    gender
    minAge
    maxAge
    abilityLevelRange
    eventDiscipline {
      disciplineName
      id
    }
    categoryCourses {
      id
      course {
        difficultyName
        id
      }
    }
    id
  }
}

fragment RelatedEvents_public_event on event {
  id
  cuid
  activity
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  organizer {
    name
    id
  }
}

fragment ReviewsSection_public_event on event {
  eventMetadata {
    cuid
    name
    id
  }
}

fragment ScheduleSection_public_event on event {
  id
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    clinicDays {
      cuid
      startTime
      eventClinicDayDuration {
        dayNumber
        duration
        id
      }
      id
    }
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    rideDays {
      cuid
      startTime
      dayNumber
      id
    }
    id
  }
  eventScheduleDates(order_by: {date: asc}) {
    id
    cuid
    date
    dayNumber
    eventSchedules {
      id
      cuid
      title
      startTime
      endTime
      description
      addedInternally
      event {
        cuid
        isVirtualEvent
        occurrenceLabel
        organizer {
          slug
          id
        }
        eventMetadata {
          isCategoriedEvent
          slug
          name
          id
        }
        eventVenues {
          venue {
            city
            state
            country
            fullAddress
            address
            id
          }
          id
        }
        id
      }
      eventScheduleDate {
        date
        id
      }
      eventScheduleTypeCustom {
        id
        cuid
        type
        color
        isPreset
      }
      eventScheduleTypePreset {
        id
        cuid
        isPreset
        scheduleTypePresetCuid
        scheduleTypePreset {
          id
          cuid
          type
          color
          isPreset
        }
      }
      eventScheduleCategories {
        id
        categoryCuid
        category {
          id
          name
        }
      }
    }
  }
}

fragment SeeDatesDialog_public_event on event {
  activity
  nonCategoriedRegDeadline
  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    spotsAvailable
    spotsRemaining
    meetingLink
    registrationStatus
    event {
      currencyCode
      isVirtualEvent
      nonCategoriedRegDeadline
      organizer {
        cuid
        id
      }
      eventMetadata {
        name
        id
      }
      eventVirtualVenues {
        timezone
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      eventPrograms {
        defaultPrice
        id
      }
      id
    }
    clinicDays {
      cuid
      startTime
      eventClinicDayDuration {
        dayNumber
        duration
        id
      }
      id
    }
    id
  }
  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: "Open"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {
    cuid
    priceOverride
    spotsAvailable
    spotsRemaining
    registrationStatus
    event {
      currencyCode
      nonCategoriedRegDeadline
      organizer {
        cuid
        id
      }
      eventMetadata {
        name
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      id
    }
    rideDays {
      cuid
      startTime
      id
    }
    id
  }
}

fragment SeriesSection_public_event on event {
  id
  cuid
  slug
  eventSeries(where: {deleted_at: {_is_null: true}}) {
    id
    roundNumber
    series {
      id
      cuid
      name
      organizerCuid
      description
      slug
      seriesActivity
      totalRounds
      seriesImages {
        image {
          relativeUrl
          id
        }
        id
      }
      eventSeries {
        id
        cuid
        seriesCuid
        eventCuid
        appliesToAllCategories
        eventSeriesCategories {
          id
          cuid
          categoryCuid
          eventSeriesCuid
        }
        event {
          cuid
          occurrenceLabel
          eventMetadata {
            name
            slug
            isCategoriedEvent
            id
          }
          id
        }
        series {
          name
          id
        }
        roundNumber
      }
    }
  }
}

fragment SponsorsSection_public_event on event {
  id
  eventSponsors(order_by: {position: asc}) {
    id
    cuid
    tierName
    position
    sponsor {
      id
      cuid
      name
      website
      sponsorImages {
        id
        cuid
        isDefault
        image {
          id
          relativeUrl
        }
      }
    }
  }
}

fragment TicketsSection_public_event on event {
  id
  cuid
  currencyCode
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {
    id
    cuid
    name
    description
    price
    ticketsAvailable
    visible
    eventCuid
  }
}

fragment UpdateContainer_public_event on event {
  id
  cuid
  eventUpdates(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {
    cuid
    title
    body
    deleted_at
    created_at
    userId
    user {
      firstName
      lastName
      profilePicUrl
      id
    }
    eventUpdateComments(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {
      cuid
      body
      deleted_at
      created_at
      isOrganizer
      userId
      user {
        id
        firstName
        lastName
      }
      id
    }
    id
  }
}

fragment VibeSection_public_event on event {
  cuid
  eventMetadata {
    numberOfDays
    id
  }
  eventDisciplines(order_by: {disciplineName: asc}) {
    disciplineName
    id
  }
  eventVibes {
    cuid
    ridingTimePerDayRange
    abilityLevelRange
    hasAverageSpeed
    averageSpeedRange
    intensityRange
    moreInfo
    genders
    rideType
    speedType
    id
  }
}

fragment ViewParticipantsDialog_public_event on event {
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {
    cuid
    name
    eventCuid
    id
  }
  ridesForParticipants: rides(where: {_and: [{canceledAt: {_is_null: true}}]}, order_by: [{created_at: asc}]) {
    cuid
    event {
      isVirtualEvent
      nonCategoriedRegDeadline
      eventVirtualVenues {
        timezone
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      id
    }
    rideDays {
      startTime
      dayNumber
      id
    }
    id
  }
  clinicsForParticipants: clinics(where: {_and: [{canceledAt: {_is_null: true}}]}, order_by: [{created_at: asc}]) {
    cuid
    event {
      isVirtualEvent
      nonCategoriedRegDeadline
      eventVirtualVenues {
        timezone
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      id
    }
    clinicDays {
      startTime
      eventClinicDayDuration {
        dayNumber
        id
      }
      id
    }
    id
  }
}

fragment VirtualSection_public_event on event {
  id
  additionalContactInfo
  eventVirtualVenues {
    id
    timezone
  }
}

fragment helpers_useGetIsEventAtCapacity_public_event on event {
  spotsAvailable
  registrations_aggregate(where: {_and: [{_or: [{_and: [{userId: {_neq: $userId}}, {status: {_in: [complete, in_progress]}}]}, {_and: [{userId: {_eq: $userId}}, {status: {_in: [complete]}}]}]}, {_not: {registrationCategories: {categoryCuid: {_is_null: true}}}}]}) {
    aggregate {
      count
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "eventCuid"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        } as any
    ], v1 = {
        "_is_null": true
    } as any, v2 = {
        "deleted_at": (v1 /*: any*/)
    } as any, v3 = [
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "_eq",
                                            "variableName": "eventCuid"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "cuid"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "_and.0"
                        },
                        {
                            "kind": "Literal",
                            "name": "_and.1",
                            "value": (v2 /*: any*/)
                        }
                    ],
                    "kind": "ListValue",
                    "name": "_and"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spotsAvailable",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activity",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVirtualEvent",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "occurrenceLabel",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCategoriedEvent",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "relativeUrl",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "concreteType": "image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
            (v14 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created_at",
        "storageKey": null
    } as any, v17 = {
        "disciplineName": "asc"
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disciplineName",
        "storageKey": null
    } as any, v19 = {
        "eventDiscipline": (v17 /*: any*/)
    } as any, v20 = {
        "position": "asc"
    } as any, v21 = {
        "kind": "Literal",
        "name": "where",
        "value": {
            "_and": [
                (v2 /*: any*/),
                {
                    "visible": {
                        "_eq": true
                    }
                }
            ]
        }
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abilityLevelRange",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "difficultyName",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "platformId",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "courseLength",
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "courseLengthType",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "courseLengthSecondary",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "courseLengthTypeSecondary",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "distance",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalElevationGain",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalElevationLoss",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spotsRemaining",
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventCuid",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventDisciplineCuid",
        "storageKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v38 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
    } as any, v39 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTime",
        "storageKey": null
    } as any, v40 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPreset",
        "storageKey": null
    } as any, v41 = [
        (v4 /*: any*/),
        (v6 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
        } as any,
        (v40 /*: any*/)
    ], v42 = {
        "alias": null,
        "args": null,
        "concreteType": "eventScheduleTypeCustom",
        "kind": "LinkedField",
        "name": "eventScheduleTypeCustom",
        "plural": false,
        "selections": (v41 /*: any*/),
        "storageKey": null
    } as any, v43 = {
        "alias": null,
        "args": null,
        "concreteType": "eventScheduleTypePreset",
        "kind": "LinkedField",
        "name": "eventScheduleTypePreset",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v6 /*: any*/),
            (v40 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduleTypePresetCuid",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "scheduleTypePreset",
                "kind": "LinkedField",
                "name": "scheduleTypePreset",
                "plural": false,
                "selections": (v41 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v44 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
    } as any, v45 = {
        "alias": null,
        "args": null,
        "concreteType": "eventScheduleDate",
        "kind": "LinkedField",
        "name": "eventScheduleDate",
        "plural": false,
        "selections": [
            (v44 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v46 = {
        "created_at": "asc"
    } as any, v47 = {
        "kind": "Literal",
        "name": "where",
        "value": (v2 /*: any*/)
    } as any, v48 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roundNumber",
        "storageKey": null
    } as any, v49 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliesToAllCategories",
        "storageKey": null
    } as any, v50 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryCuid",
        "storageKey": null
    } as any, v51 = [
        (v11 /*: any*/),
        (v4 /*: any*/)
    ], v52 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "info",
        "storageKey": null
    } as any, v53 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": (v20 /*: any*/)
        } as any
    ], v54 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "website",
        "storageKey": null
    } as any, v55 = {
        "alias": null,
        "args": null,
        "concreteType": "image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v14 /*: any*/)
        ],
        "storageKey": null
    } as any, v56 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultPrice",
        "storageKey": null
    } as any, v57 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "genders",
        "storageKey": null
    } as any, v58 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "_or": [
                    {
                        "spotsRemaining": (v1 /*: any*/)
                    },
                    {
                        "spotsRemaining": {
                            "_gt": 0
                        }
                    }
                ],
                "canceledAt": (v1 /*: any*/),
                "registrationStatus": {
                    "_eq": "Open"
                }
            }
        } as any
    ], v59 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceOverride",
        "storageKey": null
    } as any, v60 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registrationStatus",
        "storageKey": null
    } as any, v61 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCode",
        "storageKey": null
    } as any, v62 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nonCategoriedRegDeadline",
        "storageKey": null
    } as any, v63 = {
        "alias": null,
        "args": null,
        "concreteType": "organizer",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v64 = {
        "alias": null,
        "args": null,
        "concreteType": "eventMetadata",
        "kind": "LinkedField",
        "name": "eventMetadata",
        "plural": false,
        "selections": (v51 /*: any*/),
        "storageKey": null
    } as any, v65 = {
        "alias": null,
        "args": null,
        "concreteType": "eventProgram",
        "kind": "LinkedField",
        "name": "eventPrograms",
        "plural": true,
        "selections": [
            (v56 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v66 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
    } as any, v67 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
    } as any, v68 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v69 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
    } as any, v70 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
    } as any, v71 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lng",
        "storageKey": null
    } as any, v72 = {
        "alias": null,
        "args": null,
        "concreteType": "eventVenue",
        "kind": "LinkedField",
        "name": "eventVenues",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                    (v66 /*: any*/),
                    (v67 /*: any*/),
                    (v68 /*: any*/),
                    (v69 /*: any*/),
                    (v70 /*: any*/),
                    (v71 /*: any*/),
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v73 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dayNumber",
        "storageKey": null
    } as any, v74 = [
        (v66 /*: any*/),
        (v4 /*: any*/)
    ], v75 = {
        "alias": null,
        "args": null,
        "concreteType": "eventVirtualVenue",
        "kind": "LinkedField",
        "name": "eventVirtualVenues",
        "plural": true,
        "selections": (v74 /*: any*/),
        "storageKey": null
    } as any, v76 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullAddress",
        "storageKey": null
    } as any, v77 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneDayFee",
        "storageKey": null
    } as any, v78 = {
        "canceledAt": (v1 /*: any*/)
    } as any, v79 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": [
                (v46 /*: any*/)
            ]
        } as any,
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "_and": [
                    (v78 /*: any*/)
                ]
            }
        } as any
    ], v80 = {
        "alias": null,
        "args": null,
        "concreteType": "event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v9 /*: any*/),
            (v62 /*: any*/),
            (v75 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "eventVenue",
                "kind": "LinkedField",
                "name": "eventVenues",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "venue",
                        "kind": "LinkedField",
                        "name": "venue",
                        "plural": false,
                        "selections": (v74 /*: any*/),
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v81 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
    } as any, v82 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
    } as any, v83 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profilePicUrl",
        "storageKey": null
    } as any, v84 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": [
                {
                    "created_at": "desc"
                }
            ]
        } as any,
        (v47 /*: any*/)
    ], v85 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v86 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted_at",
        "storageKey": null
    } as any, v87 = {
        "alias": null,
        "args": null,
        "concreteType": "user",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            (v81 /*: any*/),
            (v82 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v88 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any, v89 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOrganizer",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EventProfileProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "eventConnection",
                    "kind": "LinkedField",
                    "name": "event_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "eventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_useGetIsEventAtCapacity_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "EventProfileView_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AlreadyRegisteredInfo_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "NonCategoriedRegisterMobile_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "NonCategoriedRegistrationCard_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SeeDatesDialog_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoriedRegistrationCard_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoriedRegisterMobile_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "RefineCategoriesCard_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OccurrenceSelector_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "EventTitle_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "DesktopPicture_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "MobilePicture_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OrganizerInfo_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "PricesCategoriedPrices_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "PricesNonCategoriedPrices_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AboutSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AdditionalInformationSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoriesSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoryInfo_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ViewParticipantsDialog_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CoursesSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SeriesSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CoachesSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VibeSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AmenitiesSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VirtualSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "LocationSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ChecklistSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ProgramSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "TicketsSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SponsorsSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OrganizerInfoSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "QuestionAnswerContainer_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "UpdateContainer_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OrganizerReviewsSection_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "RelatedEvents_public_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ReviewsSection_public_event"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EventProfileProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "eventConnection",
                    "kind": "LinkedField",
                    "name": "event_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "eventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "fields": [
                                                                        {
                                                                            "items": [
                                                                                {
                                                                                    "fields": [
                                                                                        {
                                                                                            "items": [
                                                                                                {
                                                                                                    "fields": [
                                                                                                        {
                                                                                                            "fields": [
                                                                                                                {
                                                                                                                    "kind": "Variable",
                                                                                                                    "name": "_neq",
                                                                                                                    "variableName": "userId"
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "ObjectValue",
                                                                                                            "name": "userId"
                                                                                                        }
                                                                                                    ],
                                                                                                    "kind": "ObjectValue",
                                                                                                    "name": "_and.0"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "_and.1",
                                                                                                    "value": {
                                                                                                        "status": {
                                                                                                            "_in": [
                                                                                                                "complete",
                                                                                                                "in_progress"
                                                                                                            ]
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            ],
                                                                                            "kind": "ListValue",
                                                                                            "name": "_and"
                                                                                        }
                                                                                    ],
                                                                                    "kind": "ObjectValue",
                                                                                    "name": "_or.0"
                                                                                },
                                                                                {
                                                                                    "fields": [
                                                                                        {
                                                                                            "items": [
                                                                                                {
                                                                                                    "fields": [
                                                                                                        {
                                                                                                            "fields": [
                                                                                                                {
                                                                                                                    "kind": "Variable",
                                                                                                                    "name": "_eq",
                                                                                                                    "variableName": "userId"
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "ObjectValue",
                                                                                                            "name": "userId"
                                                                                                        }
                                                                                                    ],
                                                                                                    "kind": "ObjectValue",
                                                                                                    "name": "_and.0"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "_and.1",
                                                                                                    "value": {
                                                                                                        "status": {
                                                                                                            "_in": [
                                                                                                                "complete"
                                                                                                            ]
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            ],
                                                                                            "kind": "ListValue",
                                                                                            "name": "_and"
                                                                                        }
                                                                                    ],
                                                                                    "kind": "ObjectValue",
                                                                                    "name": "_or.1"
                                                                                }
                                                                            ],
                                                                            "kind": "ListValue",
                                                                            "name": "_or"
                                                                        }
                                                                    ],
                                                                    "kind": "ObjectValue",
                                                                    "name": "_and.0"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "_and.1",
                                                                    "value": {
                                                                        "_not": {
                                                                            "registrationCategories": {
                                                                                "categoryCuid": (v1 /*: any*/)
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "_and"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "where"
                                                }
                                            ],
                                            "concreteType": "registration_aggregate",
                                            "kind": "LinkedField",
                                            "name": "registrations_aggregate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "registration_aggregate_fields",
                                                    "kind": "LinkedField",
                                                    "name": "aggregate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "count",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCourseEvent",
                                            "storageKey": null
                                        },
                                        (v10 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "refundInfo",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventMetadata",
                                            "kind": "LinkedField",
                                            "name": "eventMetadata",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v4 /*: any*/),
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "where",
                                                            "value": {
                                                                "_and": [
                                                                    (v2 /*: any*/),
                                                                    {
                                                                        "eventAccess": {
                                                                            "_eq": "Public"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": "events(where:{\"_and\":[{\"deleted_at\":{\"_is_null\":true}},{\"eventAccess\":{\"_eq\":\"Public\"}}]})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "numberOfDays",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "organizer",
                                            "kind": "LinkedField",
                                            "name": "organizer",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "about",
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "stripeConnectAccount",
                                                    "kind": "LinkedField",
                                                    "name": "stripeConnectAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "payoutsEnabled",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "chargesEnabled",
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": (v17 /*: any*/)
                                                }
                                            ],
                                            "concreteType": "eventDiscipline",
                                            "kind": "LinkedField",
                                            "name": "eventDisciplines",
                                            "plural": true,
                                            "selections": [
                                                (v18 /*: any*/),
                                                (v4 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": "eventDisciplines(order_by:{\"disciplineName\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": [
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/)
                                                    ]
                                                },
                                                (v21 /*: any*/)
                                            ],
                                            "concreteType": "category",
                                            "kind": "LinkedField",
                                            "name": "categories",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "entryFee",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventDiscipline",
                                                    "kind": "LinkedField",
                                                    "name": "eventDiscipline",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "gender",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "minAge",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "maxAge",
                                                    "storageKey": null
                                                },
                                                (v22 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "categoryCourse",
                                                    "kind": "LinkedField",
                                                    "name": "categoryCourses",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "course",
                                                            "kind": "LinkedField",
                                                            "name": "course",
                                                            "plural": false,
                                                            "selections": [
                                                                (v23 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v24 /*: any*/),
                                                                (v25 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v32 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v33 /*: any*/),
                                                (v7 /*: any*/),
                                                (v34 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "additionalPrizes",
                                                    "storageKey": null
                                                },
                                                (v35 /*: any*/),
                                                (v36 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventScheduleCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventScheduleCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventSchedule",
                                                            "kind": "LinkedField",
                                                            "name": "eventSchedule",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v37 /*: any*/),
                                                                (v38 /*: any*/),
                                                                (v39 /*: any*/),
                                                                (v42 /*: any*/),
                                                                (v43 /*: any*/),
                                                                (v45 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "categories(order_by:[{\"eventDiscipline\":{\"disciplineName\":\"asc\"}},{\"position\":\"asc\"}],where:{\"_and\":[{\"deleted_at\":{\"_is_null\":true}},{\"visible\":{\"_eq\":true}}]})"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": (v46 /*: any*/)
                                                },
                                                (v21 /*: any*/)
                                            ],
                                            "concreteType": "eventTicket",
                                            "kind": "LinkedField",
                                            "name": "eventTickets",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "price",
                                                    "storageKey": null
                                                },
                                                (v33 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ticketsAvailable",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "visible",
                                                    "storageKey": null
                                                },
                                                (v35 /*: any*/)
                                            ],
                                            "storageKey": "eventTickets(order_by:{\"created_at\":\"asc\"},where:{\"_and\":[{\"deleted_at\":{\"_is_null\":true}},{\"visible\":{\"_eq\":true}}]})"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                (v47 /*: any*/)
                                            ],
                                            "concreteType": "eventSeries",
                                            "kind": "LinkedField",
                                            "name": "eventSeries",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v48 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "series",
                                                    "kind": "LinkedField",
                                                    "name": "series",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v11 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "organizerCuid",
                                                            "storageKey": null
                                                        },
                                                        (v33 /*: any*/),
                                                        (v13 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "seriesActivity",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "totalRounds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "seriesImage",
                                                            "kind": "LinkedField",
                                                            "name": "seriesImages",
                                                            "plural": true,
                                                            "selections": [
                                                                (v15 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventSeries",
                                                            "kind": "LinkedField",
                                                            "name": "eventSeries",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "seriesCuid",
                                                                    "storageKey": null
                                                                },
                                                                (v35 /*: any*/),
                                                                (v49 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "eventSeriesCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventSeriesCategories",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v50 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "eventSeriesCuid",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "event",
                                                                    "kind": "LinkedField",
                                                                    "name": "event",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "eventMetadata",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v11 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "series",
                                                                    "kind": "LinkedField",
                                                                    "name": "series",
                                                                    "plural": false,
                                                                    "selections": (v51 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                (v48 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventSeries(where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": {
                                                        "amenity": {
                                                            "name": "asc"
                                                        }
                                                    }
                                                }
                                            ],
                                            "concreteType": "eventAmenity",
                                            "kind": "LinkedField",
                                            "name": "eventAmenities",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "amenity",
                                                    "kind": "LinkedField",
                                                    "name": "amenity",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v11 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "imageUrl",
                                                            "storageKey": null
                                                        },
                                                        (v52 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventAmenities(order_by:{\"amenity\":{\"name\":\"asc\"}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventChecklistItem",
                                            "kind": "LinkedField",
                                            "name": "eventChecklistItems",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v11 /*: any*/),
                                                (v52 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v53 /*: any*/),
                                            "concreteType": "eventSponsor",
                                            "kind": "LinkedField",
                                            "name": "eventSponsors",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "tierName",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "position",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sponsor",
                                                    "kind": "LinkedField",
                                                    "name": "sponsor",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v54 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "sponsorImage",
                                                            "kind": "LinkedField",
                                                            "name": "sponsorImages",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault",
                                                                    "storageKey": null
                                                                },
                                                                (v55 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventSponsors(order_by:{\"position\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventAdditionalInfo",
                                            "kind": "LinkedField",
                                            "name": "eventAdditionalInfos",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v37 /*: any*/),
                                                (v33 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventProgram",
                                            "kind": "LinkedField",
                                            "name": "eventPrograms",
                                            "plural": true,
                                            "selections": [
                                                (v56 /*: any*/),
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overview",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "skills",
                                                    "storageKey": null
                                                },
                                                (v57 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focus",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ageRange",
                                                    "storageKey": null
                                                },
                                                (v22 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v58 /*: any*/),
                                            "concreteType": "ride",
                                            "kind": "LinkedField",
                                            "name": "rides",
                                            "plural": true,
                                            "selections": [
                                                (v59 /*: any*/),
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v34 /*: any*/),
                                                (v60 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v61 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v62 /*: any*/),
                                                        (v63 /*: any*/),
                                                        (v64 /*: any*/),
                                                        (v65 /*: any*/),
                                                        (v72 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "rideDay",
                                                    "kind": "LinkedField",
                                                    "name": "rideDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v38 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v73 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "rides(where:{\"_or\":[{\"spotsRemaining\":{\"_is_null\":true}},{\"spotsRemaining\":{\"_gt\":0}}],\"canceledAt\":{\"_is_null\":true},\"registrationStatus\":{\"_eq\":\"Open\"}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v58 /*: any*/),
                                            "concreteType": "clinic",
                                            "kind": "LinkedField",
                                            "name": "clinics",
                                            "plural": true,
                                            "selections": [
                                                (v59 /*: any*/),
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v34 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "meetingLink",
                                                    "storageKey": null
                                                },
                                                (v60 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v61 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v62 /*: any*/),
                                                        (v63 /*: any*/),
                                                        (v64 /*: any*/),
                                                        (v65 /*: any*/),
                                                        (v75 /*: any*/),
                                                        (v72 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "clinicDay",
                                                    "kind": "LinkedField",
                                                    "name": "clinicDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v38 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventClinicDayDuration",
                                                            "kind": "LinkedField",
                                                            "name": "eventClinicDayDuration",
                                                            "plural": false,
                                                            "selections": [
                                                                (v73 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "duration",
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "clinics(where:{\"_or\":[{\"spotsRemaining\":{\"_is_null\":true}},{\"spotsRemaining\":{\"_gt\":0}}],\"canceledAt\":{\"_is_null\":true},\"registrationStatus\":{\"_eq\":\"Open\"}})"
                                        },
                                        (v61 /*: any*/),
                                        (v62 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "regCloseDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "canceledAt",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRegistrationPaused",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventVenue",
                                            "kind": "LinkedField",
                                            "name": "eventVenues",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "venue",
                                                    "kind": "LinkedField",
                                                    "name": "venue",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v66 /*: any*/),
                                                        (v67 /*: any*/),
                                                        (v68 /*: any*/),
                                                        (v69 /*: any*/),
                                                        (v70 /*: any*/),
                                                        (v71 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v76 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "parkingInfo",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "campingDescription",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "additionalInfo",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v75 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v53 /*: any*/),
                                            "concreteType": "eventImage",
                                            "kind": "LinkedField",
                                            "name": "eventImages",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v55 /*: any*/)
                                            ],
                                            "storageKey": "eventImages(order_by:{\"position\":\"asc\"})"
                                        },
                                        (v33 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "eventWebsite",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventSanction",
                                            "kind": "LinkedField",
                                            "name": "eventSanctions",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "otherSanctionName",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "permit",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "sanctionCuid",
                                                    "storageKey": null
                                                },
                                                (v49 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "allowOneDayLicense",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isLicenseRequired",
                                                    "storageKey": null
                                                },
                                                (v77 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventSanctionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventSanctionCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v50 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventSanctionCuid",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sanction",
                                                    "kind": "LinkedField",
                                                    "name": "sanction",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v11 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "hasPermit",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "waiverLink",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isOneDayAvailable",
                                                            "storageKey": null
                                                        },
                                                        (v69 /*: any*/),
                                                        (v54 /*: any*/),
                                                        (v77 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": "ridesForParticipants",
                                            "args": (v79 /*: any*/),
                                            "concreteType": "ride",
                                            "kind": "LinkedField",
                                            "name": "rides",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v80 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "rideDay",
                                                    "kind": "LinkedField",
                                                    "name": "rideDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v38 /*: any*/),
                                                        (v73 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": "rides(order_by:[{\"created_at\":\"asc\"}],where:{\"_and\":[{\"canceledAt\":{\"_is_null\":true}}]})"
                                        },
                                        {
                                            "alias": "clinicsForParticipants",
                                            "args": (v79 /*: any*/),
                                            "concreteType": "clinic",
                                            "kind": "LinkedField",
                                            "name": "clinics",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v80 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "clinicDay",
                                                    "kind": "LinkedField",
                                                    "name": "clinicDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v38 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventClinicDayDuration",
                                                            "kind": "LinkedField",
                                                            "name": "eventClinicDayDuration",
                                                            "plural": false,
                                                            "selections": [
                                                                (v73 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": "clinics(order_by:[{\"created_at\":\"asc\"}],where:{\"_and\":[{\"canceledAt\":{\"_is_null\":true}}]})"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": [
                                                        (v19 /*: any*/),
                                                        {
                                                            "platformId": "asc_nulls_last"
                                                        },
                                                        {
                                                            "difficultyName": "asc"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "concreteType": "course",
                                            "kind": "LinkedField",
                                            "name": "courses",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "platform",
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "platformUrl",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                (v11 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v23 /*: any*/),
                                                (v36 /*: any*/),
                                                (v29 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "elevationHigh",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "elevationLow",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "elevationUnit",
                                                    "storageKey": null
                                                },
                                                (v30 /*: any*/),
                                                (v31 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "maxGrade",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "geoJson",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "startLat",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "startLng",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endLat",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endLng",
                                                    "storageKey": null
                                                },
                                                (v67 /*: any*/),
                                                (v68 /*: any*/),
                                                (v69 /*: any*/),
                                                (v35 /*: any*/),
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventDiscipline",
                                                    "kind": "LinkedField",
                                                    "name": "eventDiscipline",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "where",
                                                            "value": {
                                                                "category": (v2 /*: any*/)
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "categoryCourse",
                                                    "kind": "LinkedField",
                                                    "name": "categoryCourses",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v50 /*: any*/)
                                                    ],
                                                    "storageKey": "categoryCourses(where:{\"category\":{\"deleted_at\":{\"_is_null\":true}}})"
                                                }
                                            ],
                                            "storageKey": "courses(order_by:[{\"eventDiscipline\":{\"disciplineName\":\"asc\"}},{\"platformId\":\"asc_nulls_last\"},{\"difficultyName\":\"asc\"}])"
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": {
                                                        "date": "asc"
                                                    }
                                                }
                                            ],
                                            "concreteType": "eventScheduleDate",
                                            "kind": "LinkedField",
                                            "name": "eventScheduleDates",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/),
                                                (v44 /*: any*/),
                                                (v73 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventSchedule",
                                                    "kind": "LinkedField",
                                                    "name": "eventSchedules",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v39 /*: any*/),
                                                        (v33 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addedInternally",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "organizer",
                                                                    "kind": "LinkedField",
                                                                    "name": "organizer",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v13 /*: any*/),
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "eventMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "eventVenue",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventVenues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "venue",
                                                                            "kind": "LinkedField",
                                                                            "name": "venue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v67 /*: any*/),
                                                                                (v68 /*: any*/),
                                                                                (v69 /*: any*/),
                                                                                (v76 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "address",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v45 /*: any*/),
                                                        (v42 /*: any*/),
                                                        (v43 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventScheduleCategory",
                                                            "kind": "LinkedField",
                                                            "name": "eventScheduleCategories",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v50 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "category",
                                                                    "kind": "LinkedField",
                                                                    "name": "category",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventScheduleDates(order_by:{\"date\":\"asc\"})"
                                        },
                                        (v13 /*: any*/),
                                        {
                                            "alias": "nonCanceledClinics",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": (v78 /*: any*/)
                                                }
                                            ],
                                            "concreteType": "clinic",
                                            "kind": "LinkedField",
                                            "name": "clinics",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "clinicCoach",
                                                    "kind": "LinkedField",
                                                    "name": "clinicCoaches",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "coach",
                                                            "kind": "LinkedField",
                                                            "name": "coach",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "user",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v81 /*: any*/),
                                                                        (v82 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "pronouns",
                                                                            "storageKey": null
                                                                        },
                                                                        (v83 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "instagramProfile",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "facebookProfile",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "stravaProfile",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "coach",
                                                                            "kind": "LinkedField",
                                                                            "name": "coach",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isSuperCoach",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "allowRequests",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "organizerCuidToDisplay",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "coachingVibe",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "coachDiscipline",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "coachDisciplines",
                                                                                    "plural": true,
                                                                                    "selections": (v51 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "coachStudent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "coachStudents",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "languages",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v4 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "coachLocation",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "coachLocations",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v67 /*: any*/),
                                                                                        (v68 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "countryCode",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v69 /*: any*/),
                                                                                        (v4 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "organizer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organizer",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v11 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v4 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": "clinics(where:{\"canceledAt\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventVibe",
                                            "kind": "LinkedField",
                                            "name": "eventVibes",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ridingTimePerDayRange",
                                                    "storageKey": null
                                                },
                                                (v22 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasAverageSpeed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "averageSpeedRange",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "intensityRange",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "moreInfo",
                                                    "storageKey": null
                                                },
                                                (v57 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rideType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "speedType",
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "additionalContactInfo",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v84 /*: any*/),
                                            "concreteType": "eventQuestion",
                                            "kind": "LinkedField",
                                            "name": "eventQuestions",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v37 /*: any*/),
                                                (v85 /*: any*/),
                                                (v86 /*: any*/),
                                                (v16 /*: any*/),
                                                (v87 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v84 /*: any*/),
                                                    "concreteType": "eventQuestionAnswer",
                                                    "kind": "LinkedField",
                                                    "name": "eventQuestionAnswers",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v88 /*: any*/),
                                                        (v86 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v89 /*: any*/),
                                                        (v85 /*: any*/),
                                                        (v87 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": "eventQuestionAnswers(order_by:[{\"created_at\":\"desc\"}],where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": "eventQuestions(order_by:[{\"created_at\":\"desc\"}],where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v84 /*: any*/),
                                            "concreteType": "eventUpdate",
                                            "kind": "LinkedField",
                                            "name": "eventUpdates",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v37 /*: any*/),
                                                (v88 /*: any*/),
                                                (v86 /*: any*/),
                                                (v16 /*: any*/),
                                                (v85 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "user",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        (v81 /*: any*/),
                                                        (v82 /*: any*/),
                                                        (v83 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v84 /*: any*/),
                                                    "concreteType": "eventUpdateComment",
                                                    "kind": "LinkedField",
                                                    "name": "eventUpdateComments",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v88 /*: any*/),
                                                        (v86 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v89 /*: any*/),
                                                        (v85 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "user",
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v81 /*: any*/),
                                                                (v82 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": "eventUpdateComments(order_by:[{\"created_at\":\"desc\"}],where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": "eventUpdates(order_by:[{\"created_at\":\"desc\"}],where:{\"deleted_at\":{\"_is_null\":true}})"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "123089216f3c06d6db3ddcb30b58b9af",
            "id": null,
            "metadata": {},
            "name": "EventProfileProviderQuery",
            "operationKind": "query",
            "text": "query EventProfileProviderQuery(\n  $eventCuid: String!\n  $userId: String!\n) {\n  event_connection(where: {_and: [{cuid: {_eq: $eventCuid}}, {deleted_at: {_is_null: true}}]}) {\n    edges {\n      node {\n        id\n        publishedAt\n        cuid\n        ...helpers_useGetIsEventAtCapacity_public_event\n        ...EventProfileView_event\n        ...AlreadyRegisteredInfo_event\n        ...NonCategoriedRegisterMobile_public_event\n        ...NonCategoriedRegistrationCard_public_event\n        ...SeeDatesDialog_public_event\n        ...CategoriedRegistrationCard_public_event\n        ...CategoriedRegisterMobile_public_event\n        ...RefineCategoriesCard_public_event\n        ...OccurrenceSelector_public_event\n        ...EventTitle_public_event\n        ...DesktopPicture_public_event\n        ...MobilePicture_public_event\n        ...OrganizerInfo_public_event\n        ...PricesCategoriedPrices_public_event\n        ...PricesNonCategoriedPrices_public_event\n        ...AboutSection_public_event\n        ...AdditionalInformationSection_public_event\n        ...CategoriesSection_public_event\n        ...CategoryInfo_public_event\n        ...ViewParticipantsDialog_public_event\n        ...CoursesSection_public_event\n        ...ScheduleSection_public_event\n        ...SeriesSection_public_event\n        ...CoachesSection_public_event\n        ...VibeSection_public_event\n        ...AmenitiesSection_public_event\n        ...VirtualSection_public_event\n        ...LocationSection_public_event\n        ...ChecklistSection_public_event\n        ...ProgramSection_public_event\n        ...TicketsSection_public_event\n        ...SponsorsSection_public_event\n        ...OrganizerInfoSection_public_event\n        ...QuestionAnswerContainer_public_event\n        ...UpdateContainer_public_event\n        ...OrganizerReviewsSection_public_event\n        ...RelatedEvents_public_event\n        ...ReviewsSection_public_event\n      }\n    }\n  }\n}\n\nfragment AboutSection_public_event on event {\n  id\n  description\n}\n\nfragment AdditionalInformationSection_public_event on event {\n  id\n  refundInfo\n  eventWebsite\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    entryFee\n    id\n  }\n  eventAdditionalInfos {\n    id\n    title\n    description\n  }\n}\n\nfragment AlreadyRegisteredInfo_event on event {\n  cuid\n  occurrenceLabel\n  eventMetadata {\n    name\n    id\n  }\n}\n\nfragment AmenitiesSection_public_event on event {\n  id\n  eventAmenities(order_by: {amenity: {name: asc}}) {\n    id\n    amenity {\n      id\n      name\n      imageUrl\n      info\n    }\n  }\n}\n\nfragment CategoriedRegisterMobile_public_event on event {\n  cuid\n  activity\n  publishedAt\n  startDate\n  endDate\n  canceledAt\n  isVirtualEvent\n  regCloseDate\n  currencyCode\n  occurrenceLabel\n  isRegistrationPaused\n  eventMetadata {\n    isCategoriedEvent\n    slug\n    name\n    id\n  }\n  organizer {\n    slug\n    cuid\n    id\n  }\n  eventVenues {\n    venue {\n      id\n      timezone\n      city\n      state\n      country\n      lat\n      lng\n    }\n    id\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n    entryFee\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n}\n\nfragment CategoriedRegistrationCard_public_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  startDate\n  endDate\n  publishedAt\n  regCloseDate\n  canceledAt\n  isVirtualEvent\n  isRegistrationPaused\n  occurrenceLabel\n  eventMetadata {\n    slug\n    name\n    id\n  }\n  organizer {\n    id\n    cuid\n    name\n    slug\n  }\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n    cuid\n    name\n    entryFee\n    eventDiscipline {\n      disciplineName\n      id\n    }\n  }\n  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {\n    id\n    cuid\n    name\n    price\n  }\n  eventVenues {\n    id\n    venue {\n      id\n      timezone\n      city\n      state\n      country\n      lat\n      lng\n    }\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n}\n\nfragment CategoriesSection_public_event on event {\n  id\n  cuid\n  currencyCode\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    cuid\n    disciplineName\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n    cuid\n    name\n    entryFee\n    gender\n    minAge\n    maxAge\n    description\n    spotsAvailable\n    spotsRemaining\n    abilityLevelRange\n    additionalPrizes\n    eventCuid\n    eventDisciplineCuid\n    eventDiscipline {\n      disciplineName\n      id\n    }\n    categoryCourses {\n      id\n      course {\n        id\n        cuid\n        name\n        platformId\n        courseLength\n        courseLengthType\n        courseLengthSecondary\n        courseLengthTypeSecondary\n        difficultyName\n        distance\n        totalElevationGain\n        totalElevationLoss\n        fullName\n      }\n    }\n    eventScheduleCategories {\n      id\n      eventSchedule {\n        id\n        title\n        startTime\n        endTime\n        eventScheduleTypeCustom {\n          id\n          cuid\n          type\n          color\n          isPreset\n        }\n        eventScheduleTypePreset {\n          id\n          cuid\n          isPreset\n          scheduleTypePresetCuid\n          scheduleTypePreset {\n            id\n            cuid\n            type\n            color\n            isPreset\n          }\n        }\n        eventScheduleDate {\n          date\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment CategoryInfo_public_event on event {\n  id\n  cuid\n  eventSanctions {\n    id\n    cuid\n    eventCuid\n    otherSanctionName\n    permit\n    sanctionCuid\n    appliesToAllCategories\n    allowOneDayLicense\n    isLicenseRequired\n    oneDayFee\n    eventSanctionCategories {\n      id\n      cuid\n      categoryCuid\n      eventSanctionCuid\n    }\n    sanction {\n      id\n      cuid\n      name\n      hasPermit\n      waiverLink\n      isOneDayAvailable\n      country\n      website\n      oneDayFee\n    }\n  }\n}\n\nfragment ChecklistSection_public_event on event {\n  id\n  activity\n  eventChecklistItems {\n    id\n    name\n    info\n  }\n}\n\nfragment CoachesSection_public_event on event {\n  id\n  nonCanceledClinics: clinics(where: {canceledAt: {_is_null: true}}) {\n    clinicCoaches {\n      coach {\n        cuid\n        user {\n          id\n          firstName\n          lastName\n          slug\n          pronouns\n          profilePicUrl\n          instagramProfile\n          facebookProfile\n          stravaProfile\n          coach {\n            id\n            isSuperCoach\n            allowRequests\n            organizerCuidToDisplay\n            coachingVibe\n            coachDisciplines {\n              name\n              id\n            }\n            coachStudents {\n              languages\n              id\n            }\n            coachLocations {\n              city\n              state\n              countryCode\n              country\n              id\n            }\n            organizer {\n              name\n              slug\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment CoursesSection_public_event on event {\n  id\n  cuid\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n  }\n  courses(order_by: [{eventDiscipline: {disciplineName: asc}}, {platformId: asc_nulls_last}, {difficultyName: asc}]) {\n    id\n    platform\n    platformId\n    platformUrl\n    cuid\n    name\n    fullName\n    description\n    difficultyName\n    eventDisciplineCuid\n    distance\n    elevationHigh\n    elevationLow\n    elevationUnit\n    totalElevationGain\n    totalElevationLoss\n    maxGrade\n    geoJson\n    startLat\n    startLng\n    endLat\n    endLng\n    city\n    state\n    country\n    eventCuid\n    courseLength\n    courseLengthType\n    courseLengthSecondary\n    courseLengthTypeSecondary\n    eventDiscipline {\n      id\n      disciplineName\n    }\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n      categoryCuid\n    }\n  }\n}\n\nfragment DesktopPicture_public_event on event {\n  eventImages(order_by: {position: asc}) {\n    id\n    image {\n      id\n      relativeUrl\n    }\n  }\n}\n\nfragment EventProfileView_event on event {\n  cuid\n  activity\n  isVirtualEvent\n  isCourseEvent\n  occurrenceLabel\n  refundInfo\n  eventMetadata {\n    name\n    isCategoriedEvent\n    id\n  }\n  organizer {\n    name\n    about\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n    entryFee\n  }\n  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {\n    id\n  }\n  eventSeries(where: {deleted_at: {_is_null: true}}) {\n    id\n  }\n  eventAmenities(order_by: {amenity: {name: asc}}) {\n    id\n  }\n  eventChecklistItems {\n    id\n  }\n  eventSponsors(order_by: {position: asc}) {\n    id\n  }\n  eventAdditionalInfos {\n    id\n  }\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    priceOverride\n    id\n  }\n}\n\nfragment EventTitle_public_event on event {\n  cuid\n  activity\n  startDate\n  endDate\n  publishedAt\n  isVirtualEvent\n  eventVenues {\n    venue {\n      name\n      city\n      state\n      country\n      id\n    }\n    id\n  }\n  eventMetadata {\n    isCategoriedEvent\n    name\n    id\n  }\n}\n\nfragment LocationSection_public_event on event {\n  id\n  startDate\n  endDate\n  eventVenues {\n    id\n    parkingInfo\n    campingDescription\n    additionalInfo\n    venue {\n      lat\n      lng\n      name\n      fullAddress\n      id\n    }\n  }\n}\n\nfragment MobilePicture_public_event on event {\n  id\n  cuid\n  publishedAt\n  eventImages(order_by: {position: asc}) {\n    id\n    image {\n      id\n      relativeUrl\n    }\n  }\n}\n\nfragment NonCategoriedRegisterMobile_public_event on event {\n  currencyCode\n  occurrenceLabel\n  eventMetadata {\n    name\n    id\n  }\n}\n\nfragment NonCategoriedRegistrationCard_public_event on event {\n  cuid\n  activity\n  currencyCode\n  nonCategoriedRegDeadline\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    spotsAvailable\n    spotsRemaining\n    registrationStatus\n    event {\n      cuid\n      activity\n      currencyCode\n      isVirtualEvent\n      nonCategoriedRegDeadline\n      organizer {\n        cuid\n        id\n      }\n      eventMetadata {\n        name\n        id\n      }\n      eventPrograms {\n        defaultPrice\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          city\n          state\n          country\n          lat\n          lng\n          id\n        }\n        id\n      }\n      id\n    }\n    rideDays {\n      startTime\n      id\n    }\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    spotsAvailable\n    spotsRemaining\n    meetingLink\n    registrationStatus\n    event {\n      cuid\n      activity\n      currencyCode\n      isVirtualEvent\n      nonCategoriedRegDeadline\n      organizer {\n        cuid\n        id\n      }\n      eventMetadata {\n        name\n        id\n      }\n      eventPrograms {\n        defaultPrice\n        id\n      }\n      eventVirtualVenues {\n        timezone\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          city\n          state\n          country\n          lat\n          lng\n          id\n        }\n        id\n      }\n      id\n    }\n    clinicDays {\n      cuid\n      startTime\n      eventClinicDayDuration {\n        dayNumber\n        duration\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment OccurrenceSelector_public_event on event {\n  startDate\n  endDate\n  eventMetadata {\n    isCategoriedEvent\n    events(where: {_and: [{deleted_at: {_is_null: true}}, {eventAccess: {_eq: Public}}]}) {\n      cuid\n      occurrenceLabel\n      id\n    }\n    id\n  }\n}\n\nfragment OrganizerInfoSection_public_event on event {\n  id\n  cuid\n  activity\n  additionalContactInfo\n  occurrenceLabel\n  eventMetadata {\n    name\n    id\n  }\n  organizer {\n    cuid\n    name\n    about\n    slug\n    created_at\n    image {\n      relativeUrl\n      id\n    }\n    id\n  }\n}\n\nfragment OrganizerInfo_public_event on event {\n  id\n  activity\n  currencyCode\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  organizer {\n    id\n    name\n    slug\n    image {\n      relativeUrl\n      id\n    }\n  }\n}\n\nfragment OrganizerReviewsSection_public_event on event {\n  id\n  organizer {\n    id\n    name\n    slug\n    image {\n      id\n      relativeUrl\n    }\n  }\n}\n\nfragment PricesCategoriedPrices_public_event on event {\n  id\n  activity\n  currencyCode\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    id\n    entryFee\n  }\n}\n\nfragment PricesNonCategoriedPrices_public_event on event {\n  id\n  activity\n  currencyCode\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    clinicDays {\n      startTime\n      id\n    }\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    rideDays {\n      startTime\n      id\n    }\n    id\n  }\n}\n\nfragment ProgramSection_public_event on event {\n  id\n  cuid\n  currencyCode\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  eventPrograms {\n    id\n    cuid\n    overview\n    skills\n    genders\n    focus\n    ageRange\n    abilityLevelRange\n    defaultPrice\n  }\n}\n\nfragment QuestionAnswerContainer_public_event on event {\n  id\n  cuid\n  eventQuestions(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {\n    cuid\n    title\n    userId\n    deleted_at\n    created_at\n    user {\n      firstName\n      lastName\n      id\n    }\n    eventQuestionAnswers(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {\n      cuid\n      body\n      deleted_at\n      created_at\n      isOrganizer\n      userId\n      user {\n        firstName\n        lastName\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment RefineCategoriesCard_public_event on event {\n  id\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    cuid\n    name\n    gender\n    minAge\n    maxAge\n    abilityLevelRange\n    eventDiscipline {\n      disciplineName\n      id\n    }\n    categoryCourses {\n      id\n      course {\n        difficultyName\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RelatedEvents_public_event on event {\n  id\n  cuid\n  activity\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  organizer {\n    name\n    id\n  }\n}\n\nfragment ReviewsSection_public_event on event {\n  eventMetadata {\n    cuid\n    name\n    id\n  }\n}\n\nfragment ScheduleSection_public_event on event {\n  id\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    clinicDays {\n      cuid\n      startTime\n      eventClinicDayDuration {\n        dayNumber\n        duration\n        id\n      }\n      id\n    }\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    rideDays {\n      cuid\n      startTime\n      dayNumber\n      id\n    }\n    id\n  }\n  eventScheduleDates(order_by: {date: asc}) {\n    id\n    cuid\n    date\n    dayNumber\n    eventSchedules {\n      id\n      cuid\n      title\n      startTime\n      endTime\n      description\n      addedInternally\n      event {\n        cuid\n        isVirtualEvent\n        occurrenceLabel\n        organizer {\n          slug\n          id\n        }\n        eventMetadata {\n          isCategoriedEvent\n          slug\n          name\n          id\n        }\n        eventVenues {\n          venue {\n            city\n            state\n            country\n            fullAddress\n            address\n            id\n          }\n          id\n        }\n        id\n      }\n      eventScheduleDate {\n        date\n        id\n      }\n      eventScheduleTypeCustom {\n        id\n        cuid\n        type\n        color\n        isPreset\n      }\n      eventScheduleTypePreset {\n        id\n        cuid\n        isPreset\n        scheduleTypePresetCuid\n        scheduleTypePreset {\n          id\n          cuid\n          type\n          color\n          isPreset\n        }\n      }\n      eventScheduleCategories {\n        id\n        categoryCuid\n        category {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment SeeDatesDialog_public_event on event {\n  activity\n  nonCategoriedRegDeadline\n  clinics(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    spotsAvailable\n    spotsRemaining\n    meetingLink\n    registrationStatus\n    event {\n      currencyCode\n      isVirtualEvent\n      nonCategoriedRegDeadline\n      organizer {\n        cuid\n        id\n      }\n      eventMetadata {\n        name\n        id\n      }\n      eventVirtualVenues {\n        timezone\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      eventPrograms {\n        defaultPrice\n        id\n      }\n      id\n    }\n    clinicDays {\n      cuid\n      startTime\n      eventClinicDayDuration {\n        dayNumber\n        duration\n        id\n      }\n      id\n    }\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}, registrationStatus: {_eq: \"Open\"}, _or: [{spotsRemaining: {_is_null: true}}, {spotsRemaining: {_gt: 0}}]}) {\n    cuid\n    priceOverride\n    spotsAvailable\n    spotsRemaining\n    registrationStatus\n    event {\n      currencyCode\n      nonCategoriedRegDeadline\n      organizer {\n        cuid\n        id\n      }\n      eventMetadata {\n        name\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      id\n    }\n    rideDays {\n      cuid\n      startTime\n      id\n    }\n    id\n  }\n}\n\nfragment SeriesSection_public_event on event {\n  id\n  cuid\n  slug\n  eventSeries(where: {deleted_at: {_is_null: true}}) {\n    id\n    roundNumber\n    series {\n      id\n      cuid\n      name\n      organizerCuid\n      description\n      slug\n      seriesActivity\n      totalRounds\n      seriesImages {\n        image {\n          relativeUrl\n          id\n        }\n        id\n      }\n      eventSeries {\n        id\n        cuid\n        seriesCuid\n        eventCuid\n        appliesToAllCategories\n        eventSeriesCategories {\n          id\n          cuid\n          categoryCuid\n          eventSeriesCuid\n        }\n        event {\n          cuid\n          occurrenceLabel\n          eventMetadata {\n            name\n            slug\n            isCategoriedEvent\n            id\n          }\n          id\n        }\n        series {\n          name\n          id\n        }\n        roundNumber\n      }\n    }\n  }\n}\n\nfragment SponsorsSection_public_event on event {\n  id\n  eventSponsors(order_by: {position: asc}) {\n    id\n    cuid\n    tierName\n    position\n    sponsor {\n      id\n      cuid\n      name\n      website\n      sponsorImages {\n        id\n        cuid\n        isDefault\n        image {\n          id\n          relativeUrl\n        }\n      }\n    }\n  }\n}\n\nfragment TicketsSection_public_event on event {\n  id\n  cuid\n  currencyCode\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventTickets(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: {created_at: asc}) {\n    id\n    cuid\n    name\n    description\n    price\n    ticketsAvailable\n    visible\n    eventCuid\n  }\n}\n\nfragment UpdateContainer_public_event on event {\n  id\n  cuid\n  eventUpdates(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {\n    cuid\n    title\n    body\n    deleted_at\n    created_at\n    userId\n    user {\n      firstName\n      lastName\n      profilePicUrl\n      id\n    }\n    eventUpdateComments(where: {deleted_at: {_is_null: true}}, order_by: [{created_at: desc}]) {\n      cuid\n      body\n      deleted_at\n      created_at\n      isOrganizer\n      userId\n      user {\n        id\n        firstName\n        lastName\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment VibeSection_public_event on event {\n  cuid\n  eventMetadata {\n    numberOfDays\n    id\n  }\n  eventDisciplines(order_by: {disciplineName: asc}) {\n    disciplineName\n    id\n  }\n  eventVibes {\n    cuid\n    ridingTimePerDayRange\n    abilityLevelRange\n    hasAverageSpeed\n    averageSpeedRange\n    intensityRange\n    moreInfo\n    genders\n    rideType\n    speedType\n    id\n  }\n}\n\nfragment ViewParticipantsDialog_public_event on event {\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {_and: [{deleted_at: {_is_null: true}}, {visible: {_eq: true}}]}, order_by: [{eventDiscipline: {disciplineName: asc}}, {position: asc}]) {\n    cuid\n    name\n    eventCuid\n    id\n  }\n  ridesForParticipants: rides(where: {_and: [{canceledAt: {_is_null: true}}]}, order_by: [{created_at: asc}]) {\n    cuid\n    event {\n      isVirtualEvent\n      nonCategoriedRegDeadline\n      eventVirtualVenues {\n        timezone\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      id\n    }\n    rideDays {\n      startTime\n      dayNumber\n      id\n    }\n    id\n  }\n  clinicsForParticipants: clinics(where: {_and: [{canceledAt: {_is_null: true}}]}, order_by: [{created_at: asc}]) {\n    cuid\n    event {\n      isVirtualEvent\n      nonCategoriedRegDeadline\n      eventVirtualVenues {\n        timezone\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      id\n    }\n    clinicDays {\n      startTime\n      eventClinicDayDuration {\n        dayNumber\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment VirtualSection_public_event on event {\n  id\n  additionalContactInfo\n  eventVirtualVenues {\n    id\n    timezone\n  }\n}\n\nfragment helpers_useGetIsEventAtCapacity_public_event on event {\n  spotsAvailable\n  registrations_aggregate(where: {_and: [{_or: [{_and: [{userId: {_neq: $userId}}, {status: {_in: [complete, in_progress]}}]}, {_and: [{userId: {_eq: $userId}}, {status: {_in: [complete]}}]}]}, {_not: {registrationCategories: {categoryCuid: {_is_null: true}}}}]}) {\n    aggregate {\n      count\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '48f4b871d9572868cdfeab1ab3595c47';
export default node;
